import {usePageText} from '../context/page-text-context';
import {format, isMobile} from '../utils/phone-number';

function ContactNumber(props) {
  const {
    maskedPhoneNumber,
    technician: {name: technicianName},
  } = props;

  const {contactNumber} = usePageText();

  const phoneNumber = `tel:+1${maskedPhoneNumber}`;

  return (
    <div style={{display: 'flex', flex: 1, paddingLeft: '45px'}}>
      {isMobile ? (
        <p>
          {contactNumber.note} {technicianName} {contactNumber.number}
          <a href={phoneNumber}>{format(maskedPhoneNumber)}</a>.
        </p>
      ) : (
        `${contactNumber.note} ${technicianName} ${contactNumber.number} ${format(maskedPhoneNumber)}`
      )}
    </div>
  );
}

export default ContactNumber;
